import { Box, Typography, TypographyVariant } from '@mui/material';
import * as styles from '@theme/styles';

const contentStyle = {
  display: 'inline-block',
  width: '100%',
  minWidth: '0px',
  color: 'secondary.main',
} as const;

export interface ITextClickable {
  text: string;
  variant: TypographyVariant;
  buttonText?: string;
  onClick?: () => void;
}

// TODO Rip and replace with a link or a button? 6/19
export const TextClickable = ({ text, variant, buttonText, onClick }: ITextClickable) => (
  <Box id='textClickableId' sx={[contentStyle, styles.ellipsis]}>
    <Typography noWrap variant={variant}>
      {text}
    </Typography>
    {buttonText && onClick ? (
      <Typography
        noWrap
        variant={`${variant}Bold` as TypographyVariant}
        onClick={onClick}
        sx={{
          color: 'info.main',
          cursor: 'pointer',
        }}
      >
        {buttonText}
      </Typography>
    ) : null}
  </Box>
);
